import { Button } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";

const SetMyRoleButton = ({ handleOnClick }) => {
  const colors = useColors();

  return (
    <Button
      variant="outlined"
      sx={{
        backgroundColor: colors.feasibility_medium_bg,
        "&:hover": {
          backgroundColor: colors.feasibility_medium_bg_hover,
        },
      }}
      onClick={handleOnClick}
    >
      Set My Role
    </Button>
  );
};

export default SetMyRoleButton;
